import { FeatureFlagNames, useFeatureFlags } from "@/providers/featureFlags";
import { useSelectedOrganization } from "@/components/common/OrganizationSwitcher/hooks";

import { isDemoKitOrgRecord } from "../demoKitOrg";

export const useDemoKitHideExtraneousPagesEnabled = (): boolean => {
  const { isEnabled } = useFeatureFlags();
  return isEnabled(FeatureFlagNames.DemoKitHideExtraneousPages);
};

/** Page hiding applies only when the flag is on for the selected demo kit org. */
export const useHideDemoKitExtraneousPages = (): boolean => {
  const [selectedOrg] = useSelectedOrganization();
  const enabled = useDemoKitHideExtraneousPagesEnabled();
  return enabled && isDemoKitOrgRecord(selectedOrg);
};
